module.exports = __webpack_public_path__ + "img/wxerweima.b54aa731.jpg";